
import type { Enableable, Schedulable } from '@empathyco/playboard-core-domain'
import type { PropType } from 'vue'
import type Vue from 'vue'
import type { AppMessages } from '../../../../models/i18n/app.messages'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { ColorEnum } from '../../../../enums'
import { ScheduleUtils } from '../../../../utils/schedule.utils'
import { EpbPill } from '../../../shared/epb-pill'

interface State {
  color: ColorEnum
  message: string
}

type Configuration = Schedulable & Enableable

function isConfigurationActive(configuration: Configuration): boolean {
  return configuration.enabled && ScheduleUtils.isScheduleActive(configuration.schedule)
}

export default defineComponent({
  name: 'ToolReportingAsideConfigurationState',
  components: {
    EpbPill,
  },
  props: {
    configuration: {
      type: Object as PropType<Configuration>,
      required: true,
    },
  },
  setup(props: { configuration: Configuration }) {
    const {
      proxy: { $epb },
    } = getCurrentInstance() as { proxy: Vue }

    const messages = $epb.messages.app as AppMessages

    const states: Record<'active' | 'inactive', State> = {
      active: {
        color: ColorEnum.SUCCESS,
        message: messages.state.active,
      },
      inactive: {
        color: ColorEnum.ERROR,
        message: messages.state.inactive,
      },
    }

    const state = computed(() =>
      isConfigurationActive(props.configuration) ? states.active : states.inactive,
    )

    return {
      state,
    }
  },
})
